import { Group, Vector3 } from "three";
import { ViewType } from "../../Models/AppModel.js";
import { CustomLine } from "../Primitive/CustomLine.js";
import { DraggablePoint } from "../Primitive/DraggablePoint.js";
import { Config } from "../../Config/Config.js";
/**
 * Create a shape registering N points. Used to calibrate.
 */
export class CalibrationShapeBase extends Group {
    constructor(viewType) {
        super();
        this._pan = new Vector3();
        this._tolerance = 10 ** -4;
        this.name = "Calibration tool";
        this.add(this.A = new DraggablePoint("A", viewType, Config.calibrationTool_colorHex, undefined, undefined, false, Config.calib_point_scale), this.B = new DraggablePoint("B", viewType, Config.calibrationTool_colorHex, undefined, undefined, false, Config.calib_point_scale), this.C = new DraggablePoint("C", viewType, Config.calibrationTool_colorHex, this.A.position.clone().lerp(this.B.position, 0.5), undefined, false, Config.calib_point_scale), this._shape = new CustomLine("Shape", Config.calibrationTool_colorHex));
        this._isCalibratingKey = viewType === ViewType.AP ? "calibratingAP" : "calibratingLT";
        this._isRegisteringClickKey = viewType === ViewType.AP ? "isRegistering2ClickAP" : "isRegistering2ClickLT";
        this.bindProperty("visible", (m) => { return m[this._isCalibratingKey]; }, [this._isCalibratingKey]);
        this.bindProperties();
        this.bindEvents();
    }
    bindEvents() {
        this.A.bindEvent("onDragMove", (args) => this.C.position.copy(args.position).lerp(this.B.position, 0.5));
        this.B.bindEvent("onDragMove", (args) => this.C.position.copy(args.position).lerp(this.A.position, 0.5));
        this.C.bindEvent("onDragMove", (args) => this.translateAB(args.position));
        this.bindEvent("onAfterDragMove", () => this.update());
    }
    bindProperties() {
        this.A.bindProperty("visible", (m) => { return !m[this._isRegisteringClickKey]; }, [this._isRegisteringClickKey]);
        this.B.bindProperty("visible", (m) => { return !m[this._isRegisteringClickKey]; }, [this._isRegisteringClickKey]);
        this.C.bindProperty("visible", (m) => { return !m[this._isRegisteringClickKey]; }, [this._isRegisteringClickKey]);
    }
    translateAB(newCenter) {
        this._pan.copy(this.C.position).sub(newCenter);
        this.A.position.sub(this._pan);
        this.B.position.sub(this._pan);
    }
    onRegPoint(point) {
        this._registeredPoints.push(point);
    }
    onRegError() {
        this.start();
    }
    start() {
        //dispose points nel register tool check TODO
        this._registeredPoints = [];
        this._shape.setGeoPoints([]);
    }
    /**
     * Get scale factor based according to registered points.
     */
    getScaleFactor(realLength) {
        const length = this.A.position.distanceTo(this.B.position);
        return realLength / length;
    }
}
//# sourceMappingURL=CalibrationShapeBase.js.map